const WbsAccordion = () => {
    const accordionCards = document.querySelectorAll('.wbs-cookie-modal__card');

    if (accordionCards.length > 0) {
        accordionCards.forEach(accordion=>{
            const btn = accordion.querySelector('button');

            btn.addEventListener('click', ()=>{
                accordion.classList.toggle('active');
            });
        })
    }
}

export default WbsAccordion;